module.exports = __webpack_public_path__ + "img/logoDark.9d165bad.svg";